import { createContext } from "react";
import { IContextCompany } from "../types/company.interface";

const CompanyScreen = createContext<IContextCompany>({});

export default CompanyScreen;
